import React, { useContext, Suspense } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Loading from '../components/Loading'
import UserContext from '../data/user'
import PublicPages from './public'

const PrivatePagesComponent = React.lazy(() => import('./private'))

const PrivatePages = () => {
    const userCTX = useContext(UserContext)
    const location = useLocation()
    if (!userCTX.activeUser) {
        window?.sessionStorage?.setItem('requestedUrl', location.pathname)
    }
    return userCTX.activeUser ? (
        <Suspense fallback={<Loading />}>
            <PrivatePagesComponent />
        </Suspense>
    ) : (
        <Navigate to="/login" />
    )
}
const Pages = () => {
    return (
        <Routes>
            <Route path="/my/*" element={<PrivatePages />}></Route>
            <Route path="/*" element={<PublicPages />}></Route>
        </Routes>
    )
}

export default Pages
